import React, { useEffect, useMemo, useState } from "react";
import { Box, Grid, IconButton, CircularProgress } from "@mui/material";
import {
    SaveRounded,
} from "@mui/icons-material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import CustomTextField from "../common/CustomTextField";
import CustomAutocomplete from "../common/CustomAutoComplete";
import CustomButton from "../common/CustomButton";
import { genericGet } from "../../services/apiServices"
import { GET_UNIT_LIST, CREATE_UNIT_LIST, DELETE_UNIT_lIST } from "../../services/apiRoutes";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { genericPost } from '../../services/authServices';
import MessageBox from "../common/CustomMessageBox";
import CustomDelete from "../common/CustomDeleteAlert";
import { getUnitQualityCode } from "../../services/CommonServices";
import CustomMaster from "../common/CustomMaster";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import axios from "axios";
import CustomModal from "../common/CustomModal";
import UpdateUnitMaster from "./UpdateMaster/UpdateUnitMaster";


const title = "Unit Master";

const UnitValidationSchema = Yup.object().shape({
    unitName: Yup.string().required('Short Name is required'),
    unitType: Yup.string().required('unit Type is required'),
    formalName: Yup.string().required('Formal Name is required'),
    unitQualityCode: Yup.number().required('Unit Quality Code is required'),
    noOfDecimalPlaces: Yup.number().min(0, 'Cannot be negative').required('No. of Decimal Places is required'),
});
const UnitMaster = () => {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [unitMasterList, setUnitMasterList] = useState([]);
    const [unitQuality, setUnitQuality] = useState([]);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: 'unitType',
                header: 'Unit Type',
                tableHeader: {
                    justifyContent: 'flex-start',
                },
                size: 100,
                Cell: ({ row }) => {
                    const unitType = unitTypeOptions.find(option => option.id === row.original.unitType);
                    return unitType ? unitType.title : '';
                }
            },
            {
                accessorKey: 'shortFormOfUnit', header: 'Unit Name', tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 100
            },
            {
                accessorKey: 'formalName', header: 'Formal Name', tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 100
            },
            {
                accessorKey: 'unitQualityCode', header: 'Unit Quality Code (UQC)', tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 200
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 10,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                            <IconButton onClick={() => handleUpdateClick(row.original.productsUnitId)}>

                                <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                            </IconButton>
                            <IconButton
                                onClick={() => handleOpenDeleteAlert(row.original.productsUnitId)}
                            >
                                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                            </IconButton>
                        </div>
                    </>
                ),
            },
        ],
    );
    const handleUpdateClick = (productsUnitId) => {
        setSelectedId(productsUnitId);
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };
    const getUnitMasterList = async () => {
        setLoading(true);
        try {
            const response = await genericGet({ url: GET_UNIT_LIST });
            if (response.data) {
                const unitData = response.data.unitMasters.map((unit, index) => ({
                    ...unit,
                    unitId: unit.productsUnitId || '',
                    productsUnitId: unit.productsUnitId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    unitType: parseInt(unit.unitType) || '',
                    shortFormOfUnit: unit.unitName || '',
                    formalName: unit.formalName || '',
                    unitQualityCode: unit.unitQuality?.title || '',
                    noOfDecimalPlaces: unit.noOfDecimalPlaces || 0,
                }));
                setUnitMasterList(unitData);
                setLoading(false);

            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching unit master list", error);
        }
    };
    const getCommonData = async () => {
        const unitQualityCode = await getUnitQualityCode();
        setUnitQuality(unitQualityCode);
    }
    useEffect(() => {
        getUnitMasterList()
        getCommonData()
    }, [])
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                unitName: values.unitName,
                unitType: values.unitType,
                formalName: values.formalName,
                unitQualityCode: values.unitQualityCode,
                noOfDecimalPlaces: values.noOfDecimalPlaces,
            };
            const response = await genericPost(CREATE_UNIT_LIST, payload);
            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Unit added successfully",
                    type: "success",
                });
                setTimeout(() => {
                    getUnitMasterList();
                }, 1000);
                resetForm();
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };
    const [formData] = useState({
        unitName: '',
        unitType: '',
        formalName: '',
        unitQualityCode: '',
        noOfDecimalPlaces: '',
    });
    const handleDelete = async (productsUnitId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_UNIT_lIST(productsUnitId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                getUnitMasterList();
                setDeleteAlert(false);

            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const defaultView = 'unitmaster';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <Formik
                    initialValues={formData}
                    validationSchema={UnitValidationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, errors, touched, setFieldValue, values, handleChange }) => (
                        <Form>
                            <Grid container spacing={2} sx={{ px: "0%" }}>
                                <Grid item xs={12} md={4}>
                                    <CustomAutocomplete
                                        options={unitTypeOptions}
                                        fieldLabel="Unit Type"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={unitTypeOptions.find((option) => option.id === values.unitType) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('unitType', newValue ? newValue.id : '')
                                        }
                                        placeholder="Enter Unit Type"
                                        error={touched.unitType && !!errors.unitType}
                                        helperText={touched.unitType && errors.unitType}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomTextField
                                        placeholder="Enter Short Form"
                                        name="unitName"
                                        fieldLabel="Short Form of Unit"
                                        required
                                        value={values.unitName}
                                        onChange={handleChange}
                                        error={touched.unitName && !!errors.unitName}
                                        helperText={touched.unitName && errors.unitName}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomTextField
                                        placeholder="Enter Formal Name"
                                        name="formalName"
                                        fieldLabel="Formal Name"
                                        required
                                        value={values.formalName}
                                        onChange={handleChange}
                                        error={touched.formalName && !!errors.formalName}
                                        helperText={touched.formalName && errors.formalName}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomAutocomplete
                                        options={unitQuality}
                                        fieldLabel="Unit Quality Code (UQC)"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={unitQuality.find((option) => option.id === values.unitQualityCode) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('unitQualityCode', newValue ? newValue.id : '')
                                        }
                                        placeholder="Unit Quality Code"
                                        error={touched.unitQualityCode && !!errors.unitQualityCode}
                                        helperText={touched.unitQualityCode && errors.unitQualityCode}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomTextField
                                        placeholder="Enter Decimal Places"
                                        name="noOfDecimalPlaces"
                                        fieldLabel="No. Of Decimal Places"
                                        required
                                        type="number"
                                        value={values.noOfDecimalPlaces}
                                        onChange={handleChange}
                                        error={touched.noOfDecimalPlaces && !!errors.noOfDecimalPlaces}
                                        helperText={touched.noOfDecimalPlaces && errors.noOfDecimalPlaces}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Box style={{ paddingTop: "22px" }}>
                                        <CustomButton
                                            startIcon={<SaveRounded />}
                                            title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                            size="small"
                                            variant="contained"
                                            type="submit"
                                            disabled={isSubmitting}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <DataTable
                title={title}
                columns={columns}
                data={unitMasterList}
            />
            <CustomModal
                modalStyles={{
                    maxHeight: '40vh',
                    top: "10%",
                }}
                open={updateModal} handleClose={handleCloseUpdate}>
                <UpdateUnitMaster
                    handleClose={handleCloseUpdate}
                    productsUnitId={selectedId}
                    fetchData={getUnitMasterList}
                    setMessage={setMessage}
                    unitTypeOptions={unitTypeOptions}
                    unitQuality={unitQuality}
                />
            </CustomModal>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </>
    );
    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={mainContent} />
    );
};
export default UnitMaster;

const unitTypeOptions = [
    { title: "Simple", id: 1 },
];
